module.exports = __webpack_public_path__ + "static/img/in_review.c7524404.svg";